import {popupHandler } from './functions/popups.js';
import './functions/parallax.js';

document.addEventListener('DOMContentLoaded', (event) => {
    const galleries = document.querySelectorAll('.wp-block-gallery');
    
    galleries.forEach((gallery, index) => {
        const images = gallery.querySelectorAll('figure');
        const imageCount = images.length;
        
        gallery.classList.add('image-count-' + imageCount);
    });
});


jQuery( document ).ready( function( $ ) {

    
    // main manu toggle 
    $('#main-menu-toggle').on('click', function () {                
        if($('#main-menu-container').is(':visible')) {
            hideMainMenu();            
        } else {
            showMainMenu();
        }    
    });
    
    function showMainMenu() {
        $('#main-menu-toggle').addClass('open');
        // $('#main-menu-container').fadeIn(120);
        // $('#main-menu-container').css('right', '-40px').fadeIn(120).animate({ right: '0px' }, 120);
        $('#main-menu-container').css({ opacity: 0, right: '-20px' }).show().animate({ opacity: 1, right: '0' }, 200);;
    }
    
    function hideMainMenu() {
        $('#main-menu-toggle').removeClass('open');
        // $('#main-menu-container').fadeOut(180);
        $('#main-menu-container').animate({ opacity: 0, right: '-20px' }, 300, function() {
            $(this).hide();
        });
        // $menu.css('left', '-10px').fadeIn().animate({ left: '0' }, 300);
    }
});

